'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _style = require('./style');

var BottomSheetStyles = _reactStyle2['default'].create({

  normalBottomSheetStyle: {
    backgroundColor: 'white',
    borderTop: '1px solid ' + _style.Colors.grey.P300,
    bottom: 0,
    left: 0,
    paddingBottom: 8,
    position: 'fixed',
    right: 0,
    transition: 'transform .2s cubic-bezier(.4,0,.2,1), visibility 0s linear 0s',
    visibility: 'visible',
    zIndex: '3'
  },

  showBottomSheetStyle: {
    transform: 'translateY(0)'
  },

  titleStyle: {
    color: _style.Colors.grey.P500,
    cursor: 'default',
    padding: 16
  }
});

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
    this._isMounted = false;
    this.state = {
      height: 0
    };
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;

      // to enforce calculation of height
      this.forceUpdate();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // NOTE(berks): not sure this needs to happen always or only at CDM
      var domNode = _react2['default'].findDOMNode(this);
      var newHeight = domNode.offsetHeight + 8;
      if (this.state.height !== newHeight) {
        this.setState({ height: newHeight });
      }
    }
  }, {
    key: 'hiddenTransformStyle',
    value: function hiddenTransformStyle() {
      var height = this.state.height;

      return {
        visibility: 'hidden',
        transform: 'translateY(' + height + 'px)',
        transition: 'transform .2s cubic-bezier(.4,0,.2,1), visibility 0s linear .21s'
      };
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle(title, styles) {
      if (!title) {
        return null;
      }
      return _react2['default'].createElement(
        'div',
        { styles: styles },
        title
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var defaultStyles = BottomSheetStyles;
      var bottomSheetStyles = [defaultStyles.normalBottomSheetStyle];
      var _props = this.props;
      var children = _props.children;
      var show = _props.show;
      var styles = _props.styles;
      var title = _props.title;

      if (show) {
        bottomSheetStyles.push(defaultStyles.showBottomSheetStyle);
      } else {
        bottomSheetStyles.push(this.hiddenTransformStyle());
      }
      if (styles) {
        bottomSheetStyles = bottomSheetStyles.concat(styles);
      }

      return _react2['default'].createElement(
        'div',
        { styles: bottomSheetStyles },
        this.renderTitle(title, defaultStyles.titleStyle),
        children
      );
    }
  }], [{
    key: 'displayName',
    value: 'BottomSheet ',
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      children: _react.PropTypes.node,
      show: _react.PropTypes.bool,
      styles: _react.PropTypes.array,
      title: _react.PropTypes.string
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/BottomSheet.js
 ** module id = 184
 ** module chunks = 0
 **/